import loadLightbox, { open } from "../Lightbox/src";
import SingleDatePicker from "../DatePicker/src/DatePicker";
import ReactDOMOld from "react-dom";
import React from "react";
import { createTennisIDSignUp, IPersonProps } from "../../services/tennisID";
import nationalitySelectHTML from "./nationality";

const SignUpForm = `<div class="lightbox hide form-sign-up">
    <div class="container">
        <div class="form-sign-up__splash">
        <p class="form-sign-up__splash-heading">
            GET ACCESS TO ITF SERVICES WITH YOUR TENNIS ID
        </p>
        <div class="form-sign-up__splash-image"></div>
        <p class="form-sign-up__splash-blurb">
            Your single Tennis ID account will give you access to ITF services.
            If you already use one of these services, use the same account
            details to access the others.
        </p>
        <button
            id="sign-up-form__reveal"
            class="form-sign-up__btn mobile"
        >
            Register
        </button>
        <p class="login-text">
            Already have an account? <a href="/signin">Sign in here</a>
        </p>
        </div>
        <div class="lightbox__close"></div>
        <div class="lightbox-dialogue hidden">
        <p class="form-sign-up__heading">Sign Up</p>
        <form>
          <label name="givenName" class="first-name">
          <input required placeholder="First name*" />
          </label>
          <label name="familyName" class="last-name">
          <input required placeholder="Last name*" />
          </label>
          <label name="emailAddress" class="email full">
          <input required type="email" placeholder="Email*" />
          </label>
          <label name="countryOfResidenceCode" class="nationality full">
          ${nationalitySelectHTML}
          </label>
          <label name="dob" class="dob full">
            <span>Date of Birth* -</span>
            <div required id="date-of-birth-wrapper"></div>
          </label>
          <label name="gender" class="sex full">
          <select placeholder="Sex">
              <option value="" selected disabled hidden>Sex</option>
              <option value="f">Female</option>
              <option value="m">Male</option>
            </select>
            </label>
            <label name="terms" class="terms full checkbox">
            <input required type="checkbox" />
            <span>
                I hereby agree to <a href="#">
                <b>Terms & Conditions</b>
                </a>
            </span>
            </label>
            <label name="marketingConsent" class="newsletter full checkbox">
            <input type="checkbox" />
            <span>
                Yes, I would like to receive emails with news, information, and special offers from the ITF and on behalf of our <a href="https://www.itftennis.com/en/about-us/organisation/commercial-partners/" target="_blank">partners</a>
            </span>
            </label>
            <label class="full"><span>For details on how we use your data, please visit our <a href="https://www.itftennis.com/media/2205/itf-privacy-notice-marketing-v5-final.pdf" target="_blank">Marketing Privacy Notice</a> on the ITF website. You can unsubscribe at any time.</span></label>
            <p class="login-error-text" id="login-error" style="display: none">An account already exists with these details, please try to <a href="/signin">Log in here</a></p>
            <label class="full submit">
            <input
                class="form-sign-up__btn"
                type="submit"
                value="Sign Up"
            />
            </label>
        </form>
        <p class="login-text">
            Already have an account? <a href="/signin">Log in here</a>
        </p>
        </div>
    </div>
</div>`;

function handleInput(target: string, regex: RegExp) {
  const element = document.querySelector(target);

  if (element) {
    const input = element.querySelector("input");
    if (input) {
      input.addEventListener("input", e => {
        // @ts-ignore
        const value = e.target.value;
        if (value === "" || regex.test(value)) {
          input.style.borderColor = "#e6e6e6";
        } else {
          input.style.borderColor = "red";
        }
      });
    }
  }
}

export const SignUpFormScript = () => {
  const lb = document.createElement("div");
  lb.classList.add("tennisid-form-wrapper");
  lb.innerHTML = SignUpForm;
  const hashes = ["tennis-id", "tennis-id-sign-up", "sign-up"];
  const fields = [
    "emailAddress",
    "familyName",
    "givenName",
    "dob",
    "countryOfResidenceCode",
    "country",
    "gender",
    "marketingConsent"
  ];

  if (!document.querySelectorAll(".tennisid-form-wrapper").length) {
    const body = document.querySelector("body");
    body && body.appendChild(lb);

    ReactDOMOld.render(
      // @ts-ignore
      React.createElement(SingleDatePicker, {
        elementId: "sindle-date-picker",
        placeholder: "dd/mm/yyyy",
        displayFormat: "DD/MM/YYYY",
        isSingleDatePicker: true,
        required: true
      }),
      document.querySelector("#date-of-birth-wrapper")
    );
  }

  const getValue = (field: any) => {
    const isSelect = !!field.querySelector("select");
    const isCheckbox = !!field.querySelector("input[type=checkbox]");
    const el = isSelect
      ? Array.from(field.querySelectorAll("option")).filter(
          (op: any) => op.selected
        )[0]
      : field.querySelector("input");
    return isCheckbox ? el.checked : el.value;
  };

  const form = document.querySelector(".form-sign-up form");
  form &&
    form.addEventListener("submit", (e: Event) => {
      e.preventDefault();

      const srcElement = e.srcElement as HTMLElement;

      const completedForm = Array.from(
        srcElement.querySelectorAll("label")
      ).reduce((obj: any, field: HTMLElement) => {
        const name = field.getAttribute("name");
        if (fields.some(field => field == name) && name) {
          obj[name] = getValue(field);
        }
        return obj;
      }, {}) as IPersonProps;

      createTennisIDSignUp({ data: completedForm })
        .then(({ data }) => {
          if (data.AlreadyItfCustomer || data.AlreadyRegisteredForService) {
            const error = document.getElementById("login-error");
            if (error) {
              error.style.display = "block";
            }
          } else {
            let url = `${process.env.B2C_SIGNUP_HOST_URL}client_id=${
              process.env.B2C_SIGNUP_CLIENT_ID
            }&redirect_uri=https://${encodeURIComponent(
              location.host
            )}%2Fb2ccallback&registrationToken=${
              data.RegistrationToken
            }&email=${encodeURIComponent(
              completedForm.emailAddress
            )}&response_mode=form_post&response_type=id_token&scope=openid&clientId=itftennis`;
            location.href = url;
          }
        })
        .catch((error: Error) => {
          console.log(error);
        });
    });

  handleInput('label[name="givenName"]', /^[A-Za-z\s'-]+$/);
  handleInput('label[name="familyName"]', /^[A-Za-z\s'-]+$/);
  handleInput(
    'label[name="emailAddress"]',
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  );

  loadLightbox({
    containerClassName: ".form-sign-up",
    elClassName: "loaded",
    dynamic: false
  });

  document.querySelectorAll(".sign-up__trigger-form").forEach(el => {
    el.addEventListener("click", () => {
      open({
        className: "form-sign-up",
        containerClassName: "body"
      });
    });
  });

  if (hashes.some(hash => location.hash.toLowerCase().indexOf(hash) >= 0)) {
    open({
      className: "form-sign-up",
      containerClassName: "body"
    });
  }

  const signupReveal = document.querySelector("#sign-up-form__reveal");
  signupReveal &&
    signupReveal.addEventListener("click", () => {
      const splash = document.querySelector(".form-sign-up__splash");
      splash && splash.classList.add("hidden");

      setTimeout(() => {
        const splash = document.querySelector(".form-sign-up__splash");
        splash && splash.classList.add("invisible");
        const splashWithClose = document.querySelector(
          ".form-sign-up__splash ~ .lightbox__close"
        );
        splashWithClose && splashWithClose.classList.add("invert");
        const dialogBox = document.querySelector(
          ".form-sign-up .lightbox-dialogue"
        );
        dialogBox && dialogBox.classList.remove("hidden");
      }, 350);
    });
};
